import React, { useContext } from 'react';
import truncateWords from '../../../../format/truncateWords';
import { Link, useNavigate } from 'react-router-dom';
import { Store } from '../../../../Store';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';

const LatestNews = ({ data }) => {
  return (
    <Container className='my-5'>
      <Card>
        <Card.Body>
          <Row>
            <Col md={7}>
              <img
                data-src={data.thumbnail}
                className=" thumbnail owl-lazy zoom-image"
                alt={data.title}
                loading="lazy"
                src={data.thumbnail}
                style={{
                  width: '100%',
                  aspectRatio: '16/9',
                  objectFit: 'cover',
                  opacity: '1',
                  transition: 'transform 0.3s ease',
                }}
              />
            </Col>
            <Col md={5}>  
              <h3 className='default-box-title'>{data.title}</h3>
              <p className="text-justify">{data.short_description}</p>
              <Button variant="outline-primary float-end"  as={Link} to={`/tin-tuc/${data.slug}`}>
                Xem thêm <i className="fa fa-arrow-right"></i>
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LatestNews;
